import axios from "axios";
import React, { useEffect, useState } from "react";
import { useIndexedDB } from "react-indexed-db";
import { useAuth } from "../../context/AuthContext";
import { styled } from "../../stitches.config";
import Title from "../atoms/Title";
import Breadcrumbs from "../components/Breadcrumbs";
import PhotoOnLeft from "../components/PhotoOnLeft";
import PhotoOnTop from "../components/PhotoOnTop";
import TextOnPicture from "../components/TextOnPicture";
import Footer from "../components/Footer"

const ForYouPage = () => {
  const [data, setData] = useState<any[]>([]);
  const [visitedCategories, setVisitedCategories] = useState<any[]>([]);
  const { getAll } = useIndexedDB("visitedCategories");
  const isDesktop = window.innerWidth > 996;
  const [{ user }] = useAuth();

  const getTopThreeCategories = () => {
    const topThreeCategory = visitedCategories
      .sort((a, b) => b.count - a.count)
      .slice(0, 3);
    const topIds = topThreeCategory.map(({ categoryId }) => +categoryId);
    const topStringIds = topIds.join(",");
    return topStringIds;
  };

  const fetchFilteredData = async () => {
    const categories = getTopThreeCategories();
    const res = await axios.get(
      `${window.API_HOST}/api/for-you?` + (categories && `categories=${categories}&`) + `limit=23`
    );
    if (res.status !== 200) return;

    setData(res.data);
  };

  const fetchUserCategories = async () => {
    const res = await axios.get(
      `${window.API_HOST}/api/for-you?limit=23`
    );
    if (res.status !== 200) return;

    setData(res.data);
  };

  useEffect(() => {
    if (!user) {
      getAll().then((data) => setVisitedCategories(data));
    }
  }, []);

  useEffect(() => {
    if (user) {
      fetchUserCategories();
    } else {
      fetchFilteredData();
    }
  }, [visitedCategories]);

  const slices = [data.slice(0, 3), data.slice(3)];

  return (
    <>
      <Container>
        <Breadcrumbs category={{ name: "Dla Ciebie", link: "" }} invert />
        <Title withDots size="large" type="transparent">
          Dla Ciebie
        </Title>
        <Wrapper className="foryou__rows__wrapper">
          {slices.map((slice, sliceNo) => {
            console.log(slice);
            return (
              <div className="row">
                {slice.map((item: any, index: number) => {
                  item.author.show = sliceNo == 0 && index > 0 && index < 3;
                  return (
                    <div
                      className={
                        "col-xs-12 col-md-" + (sliceNo == 0 && index == 0 ? 6 : 3)
                      }
                    >
                      {sliceNo == 0 && index == 0 ? (
                        isDesktop ? (
                          <TextOnPicture article={item} />
                        ) : (
                          <PhotoOnTop article={item} />
                        )
                      ) : isDesktop ? (
                        <PhotoOnTop article={item} />
                      ) : (
                        <PhotoOnLeft article={item} boxSize="xs" />
                      )}
                    </div>
                  );
                })}
              </div>
            );
          })}
        </Wrapper>
      </Container>
      <Footer />
    </>
  );
};

export default ForYouPage;

const Wrapper = styled("div", {});

const Container = styled("div", {
  backgroundColor: "$grayscale10",
  padding: "34px 16px 36px 16px",
  "@bp4": {
    padding: "50px 84px 78px 84px",
  },
  "& > div:nth-child(2)": {
    marginTop: "40px",
  },
});
